module.exports = __webpack_public_path__ + "img/Martin-Matin-Max-Quality.10aed3a6.jpg";